var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.isRenderComponent,{tag:"component",attrs:{"data":_vm.data,"id":_vm.data.id}})}
var staticRenderFns = []

export { render, staticRenderFns }